export enum ScreenId {
  HOME = "/",
  PRODUCT = "/product",
  REVIEW = "/review",
}

export enum AdminScreenId {
  REVIEW_LIST = "/admin/review",
  REVIEW_DETAIL = "/admin/review_detail",
}
